import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule, Http} from '@angular/http';

import {PerfectScrollbarModule} from 'ngx-perfect-scrollbar';
import {PERFECT_SCROLLBAR_CONFIG} from 'ngx-perfect-scrollbar';
import {PerfectScrollbarConfigInterface} from 'ngx-perfect-scrollbar';

import {TranslateModule, TranslateLoader, TranslateStaticLoader} from 'ng2-translate/ng2-translate';
import {FlexLayoutModule} from '@angular/flex-layout';

import {DemoMaterialModule} from './shared/demo.module';

import {MatSidenavModule} from '@angular/material/sidenav';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTabsModule} from '@angular/material/tabs';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatCardModule} from '@angular/material/card';
import {MAT_DATE_LOCALE} from '@angular/material/core';


import {JazzDialogComponent} from './material/dialog/dialog.component';
import {FamilleMemberComponent} from './reservation/cours/cours.component';
import {FamilleMemberPlanningComponent} from './reservation/espace/espace.component';
import {AllClientComponent} from './administration/cours/cours.component';
import {AddClientEspaceComponent} from './administration/planningespace/planningespace.component';
import {CalendarDialogComponent} from './apps/fullcalendar/fullcalendar.component';

import {AppRoutes} from './app.routing';
import {AppComponent} from './app.component';
import {AdminLayoutComponent} from './layouts/admin/admin-layout.component';
import {AuthLayoutComponent} from './layouts/auth/auth-layout.component';
import {SharedModule} from './shared/shared.module';

import {ConfigService} from './shared/config.service';
import {AuthGuard} from './guards/auth.guard';
import {AuthenticationService} from './service/authentication.service';
import {ActiviteService} from './service/activite.service';
import {ClientService} from './service/client.service';
import {CoursService} from './service/cours.service';
import {EspaceService} from './service/espace.service';
import {PlanningService} from './service/planning.service';
import {ProgrammehebdoService} from './service/programmehebdo.service';
import {ReservationService} from './service/reservation.service';
import {UtilisateurService} from './service/utilisateur.service';
import {UtilsService} from './service/utils.service';


import {ServiceWorkerModule} from '@angular/service-worker';
import {environment} from '../environments/environment';

import {Config} from './app.config';
import { from } from 'rxjs/observable/from';


export function createTranslateLoader(http: Http) {
    return new TranslateStaticLoader(http, './assets/i18n', '.json');
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true
};

@NgModule({
    declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        JazzDialogComponent,
        FamilleMemberComponent,
		FamilleMemberPlanningComponent,
        AllClientComponent,
        AddClientEspaceComponent,
        CalendarDialogComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        SharedModule,
        RouterModule.forRoot(AppRoutes),
        FormsModule,
        HttpModule,
        MatSidenavModule,
        MatInputModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        MatToolbarModule,
        MatTabsModule,
        MatCheckboxModule,
        MatProgressBarModule,
        MatSelectModule,
        MatCardModule,
        DemoMaterialModule,
        TranslateModule.forRoot({
            provide: TranslateLoader,
            useFactory: (createTranslateLoader),
            deps: [Http]
        }),
        FlexLayoutModule,
        ServiceWorkerModule.register('./ngsw-worker.js', {enabled: environment.production})
         
    ],
    providers: [
        AuthGuard,
        ConfigService,
        AuthenticationService,
        ActiviteService,
        ClientService,
        CoursService,
        EspaceService,
        PlanningService,
        ProgrammehebdoService,
        ReservationService,
        UtilsService,
        UtilisateurService,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        {
            provide: MAT_DATE_LOCALE,
            useValue: 'en-GB'
        },
        {provide: Config, useFactory: () => Config.getInstance('assets/config.json')}
    ],
    entryComponents: [JazzDialogComponent, CalendarDialogComponent, FamilleMemberComponent,FamilleMemberPlanningComponent, AllClientComponent, AddClientEspaceComponent],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/codevi/Documents/PROJET/resa-parklife/front/src/app/app.module.ts